export default "__VITE_ASSET__BvjRQ6Kg__"